<template>
  <button class="button" :class="type" :style="{'flex' : fullwidth ? '1 1 auto' : ''}">
		<div :class="isLoading ? 'loader' : ''" v-text="isLoading ? '' : text"></div>
	</button>
</template>

<script>
export default {
  props: {
		type: String,
		text: String,
		fullwidth: Boolean,
		isLoading: Boolean
	}
}
</script>

<style scoped>
.button {
  color: white;
  border-radius: 4px;
  border: none;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  padding: 0.6rem 1.2rem;
  transition: .2s ease-out;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
}
.button:hover {
  background: #001b3d;
  transition: .2s ease-out;
}
.button-info {
  background: #39A2D9;
}
</style>
